import { render, staticRenderFns } from "./Block2.vue?vue&type=template&id=4034a52e&scoped=true&"
import script from "./Block2.vue?vue&type=script&lang=js&"
export * from "./Block2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4034a52e",
  null
  
)

export default component.exports